import * as http from 'utils/http';
import config from 'config';

import { baseService } from './baseService';

const DEFAULT_POI_RADIUS = 20;

const countryMapperForPOIService = {
  UK: 'GB',
};

const getZipcodeLocality = async ({ country, zipcode }) => {
  const response = await baseService('search/structured', {
    layers: 'postalcode',
    postalcode: zipcode,
    'boundary.country': countryMapperForPOIService[country] || country,
  });

  const { features } = response;

  if (!features?.length) {
    return { locality: null, localityGID: null };
  }

  const firstFeature = features[0];

  return {
    locality: firstFeature?.properties?.locality,
    localityGID: firstFeature?.properties?.locality_gid,
  };
};

const searchForCountry = async (country) => {
  return baseService('search/structured', {
    country: countryMapperForPOIService[country] || country,
  });
};

const getPlaces = async (ids) => {
  return baseService('place', {
    ids,
  });
};

const autocompleteAddresses = async (inputValue, boundaryGID) => {
  return baseService('autocomplete', {
    layers: 'street,address',
    text: inputValue,
    'boundary.gid': boundaryGID,
  });
};

const reverseGeocoding = async ({ latitude, longitude }) => {
  return baseService('reverse', {
    layers: 'venue',
    size: 40,
    'boundary.circle.radius': 2,
    'point.lat': latitude,
    'point.lon': longitude,
  });
};

const searchForDuplicates = async ({ radius = DEFAULT_POI_RADIUS, text, latitude, longitude }) => {
  return baseService('search', {
    layers: 'venue',
    sources: 'ontruck',
    text,
    'boundary.circle.radius': radius,
    'boundary.circle.lon': longitude,
    'boundary.circle.lat': latitude,
    'focus.point.lon': longitude,
    'focus.point.lat': latitude,
  });
};

const getPlaceById = async (placeId) => {
  const params = new URLSearchParams({ ids: placeId });
  return http.get(`${config.API_URL}places/?${params.toString()}`);
};

const getAddress = (addressId) => {
  return http.get(`${config.API_URL}addresses/${addressId}/`);
};

const editAddressWithPOIdata = async (addressId, poi) => {
  if (!poi) {
    return;
  }

  return http.patch(`${config.API_URL}addresses/${addressId}/`, {
    latitude: poi?.latitude,
    longitude: poi?.longitude,
    gid: poi?.id,
    match_level: 'pelias_service',
    accuracy_level: 'HIGH',
  });
};

export {
  baseService,
  getAddress,
  editAddressWithPOIdata,
  searchForDuplicates,
  getZipcodeLocality,
  searchForCountry,
  getPlaces,
  autocompleteAddresses,
  reverseGeocoding,
  getPlaceById,
};
